<template>
  <div class="modal-backdrop" @click="close">
    <div class="modal-content" @click.stop>
      <div class="modal-header">
        <h3>Save Column Mapping</h3>
        <button class="btn-close" @click="close">&times;</button>
      </div>

      <div class="modal-body">
        <div class="form-group">
          <label for="mappingName">Mapping Name</label>
          <input
            type="text"
            id="mappingName"
            v-model="mappingName"
            class="form-control"
            placeholder="Enter a name to identify this mapping"
            :class="{ 'is-invalid': nameError }"
            @input="nameError = ''"
            autofocus
          />
          <div class="form-hint" v-if="!nameError">Enter a name to identify this mapping</div>
          <div class="invalid-feedback" v-if="nameError">{{ nameError }}</div>
        </div>
      </div>

      <div class="modal-footer">
        <button
          class="btn btn-secondary"
          @click="close"
        >
          Cancel
        </button>
        <button
          class="btn btn-primary"
          :disabled="!mappingName"
          @click="save"
        >
          Save
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    mapping: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      mappingName: '',
      nameError: ''
    }
  },

  methods: {
    save() {
      if (!this.mappingName) {
        this.nameError = 'Mapping name is required';
        return;
      }

      this.$emit('save', this.mappingName);
    },

    close() {
      this.$emit('close');
    }
  }
}
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background-color: white;
  border-radius: 4px;
  width: 500px;
  max-width: 90%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  overflow: hidden;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #e0e0e0;
}

.modal-header h3 {
  margin: 0;
  font-size: 18px;
}

.btn-close {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #757575;
}

.modal-body {
  padding: 16px;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 16px;
  border-top: 1px solid #e0e0e0;
}

.form-group {
  margin-bottom: 16px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
}

.form-control {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
}

.form-control.is-invalid {
  border-color: #dc3545;
}

.form-hint {
  font-size: 12px;
  color: #757575;
  margin-top: 4px;
}

.invalid-feedback {
  font-size: 12px;
  color: #dc3545;
  margin-top: 4px;
}

.btn {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s;
}

.btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-primary {
  background-color: #1976d2;
  color: white;
}

.btn-primary:hover:not(:disabled) {
  background-color: #1565c0;
}

.btn-secondary {
  background-color: #f5f5f5;
  color: #757575;
}

.btn-secondary:hover {
  background-color: #e0e0e0;
}
</style>
